import {
  FitnessApplicationActivityType,
  MeasurementSystem,
} from '../../../../types/__generated__';
import { FitnessSettingsFormValues } from './StravaSettingsModal';

export const defaultStravaSettings: FitnessSettingsFormValues = {
  subscribedActivities: Object.values(FitnessApplicationActivityType),
  measurementSystem: MeasurementSystem.Imperial,
  showDistance: true,
  showDuration: true,
  showElevation: true,
  showPhotos: true,
  showMap: true,
  showTotaliser: true,
};

export const pausedStravaSettings: FitnessSettingsFormValues = {
  ...defaultStravaSettings,
  subscribedActivities: [],
};
